import { FC, MouseEventHandler, useState } from "react";
import Modal from "../Modal";
import { ApplicationState, AppThunkDispatch } from "../../store";
import { favoriteActionCreators } from "../../actions/favoriteActions";
import Suspense from "../suspense/Suspense";
import { connect, ConnectedProps } from "react-redux";
import { FavoriteEntry } from "../../store/favorite";

interface DeleteFavoriteEntryModalProps extends ConnectedProps<typeof connector> {
    isVisible: boolean;
    onClose: () => void;
    favoriteEntry: FavoriteEntry;
}

const DeleteFavoriteEntryModal: FC<DeleteFavoriteEntryModalProps> = (props) => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    
    const { isVisible, onClose, favoriteEntry } = props;
    const { favoriteState } = props;
    const { deleteFavoriteEntry } = props;
    
    const handleCancelButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        onClose();
    }
    
    const handleDeleteButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        setIsSubmitted(true);
        if (favoriteEntry !== null) {
            console.log("handleDeleteButtonClick");
            console.log(favoriteEntry);
            deleteFavoriteEntry(favoriteEntry.favoriteId);
        }
    }
    
    const handleCloseButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        onClose();
        setIsSubmitted(false);
    }
    
    const getMessage = () => {
        let message = "";
        message = "Are you sure you want to remove this favorite question?";
        return message;
    }
    
    const getSubmittedMessage = () => {
        return "Favorite question successfully removed.";
    }
    
    const getErrorMessage = () => {
        return "There was a problem removing the favorite. Please try again.";
    }
    
    return (
        <Modal
            isVisible={isVisible}
        >
            <Suspense isLoading={favoriteState.isLoading}>
                {!isSubmitted ? (
                    <>
                        <h2>{getMessage()}</h2>

                        <div className="drawer-split">
                            <button className="cancel" onClick={handleCancelButtonClick}>
                                <i className="fa fa-times" />  Cancel
                            </button>
                            <button className="delete" onClick={handleDeleteButtonClick}>
                                <i className="fa fa-trash" />  Remove
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <h2>{favoriteState.error ? getErrorMessage() : getSubmittedMessage()}</h2>

                        <div className="drawer-split">
                            <button className="cancel" onClick={handleCloseButtonClick}>
                                <i className="fa fa-times" />  Close
                            </button>
                        </div>
                    </>
                )}
            </Suspense>
        </Modal>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    const favoriteState = state.favorite;
    
    return { favoriteState };
}

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    deleteFavoriteEntry: (favoriteEntryId: number) => {
        dispatch(favoriteActionCreators.deleteFavoriteEntry(favoriteEntryId));
    }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(DeleteFavoriteEntryModal);